export interface DevConfig {
  enableMock: boolean
  apiBaseUrl: string
}

/**
 * 开发模式配置。
 *
 * enableMock 优先级（默认关闭——零 mock 铁律，一律走真实后端）：
 *   1. VITE_ENABLE_MOCK 环境变量（'1'/'true' → 开启 mock；其余一律关闭）
 *   2. 默认 false：REST 全部经 vite proxy 打到真实后端（见 vite.config.ts proxy 配置）
 *
 * E2E 真实联调：playwright webServer 启动 vite 时注入 VITE_ENABLE_MOCK=false，
 * 所有请求经 vite proxy 打到真实后端（见 vite.config.ts proxy 配置）。
 */
const envEnableMock = import.meta.env.VITE_ENABLE_MOCK
const enableMock = ['1', 'true', 'on'].includes(String(envEnableMock ?? '').toLowerCase())

// API 基地址：优先 VITE_API_BASE 环境变量（生产构建注入公网域名），否则走 vite proxy（开发）
// 注意：vite 静态替换 import.meta.env.VITE_X，必须直接属性访问（不能可选链）
const envApiBase = String(import.meta.env.VITE_API_BASE || '').trim()

const devConfig: DevConfig = {
  enableMock,
  apiBaseUrl: envApiBase,
}

export default devConfig
